import { render, staticRenderFns } from "./multiple-brand-toggle.vue?vue&type=template&id=33635a5a&scoped=true"
import script from "./multiple-brand-toggle.vue?vue&type=script&lang=js"
export * from "./multiple-brand-toggle.vue?vue&type=script&lang=js"
import style0 from "./multiple-brand-toggle.vue?vue&type=style&index=0&id=33635a5a&prod&lang=css"
import style1 from "./multiple-brand-toggle.vue?vue&type=style&index=1&id=33635a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33635a5a",
  null
  
)

export default component.exports